import { useState } from "react";
import { Link } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import Logo from "./Logo";

export default function Header({ t, lang, setLang }) {
  const [open, setOpen] = useState(false);
  const links = [
    { href: "/#activites", label: t.nav.activites, id: "nav-activites" },
    { href: "/#secteurs", label: t.nav.secteurs, id: "nav-secteurs" },
    { href: "/#solutions-digitales", label: t.nav.digital, id: "nav-digital" },
    { href: "/#approche", label: t.nav.approche, id: "nav-approche" },
    { href: "/#contact", label: t.nav.contact, id: "nav-contact" },
  ];
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#2A2D34]">
          {links.map((l) => (
            <Link key={l.id} to={l.href} data-testid={l.id} className="hover:text-[#5A6B7C] transition-colors">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-4 sm:gap-6">
          <div className="flex items-center gap-2 text-sm" data-testid="lang-toggle">
            <button
              data-testid="lang-fr-button"
              onClick={() => setLang("fr")}
              className={lang === "fr" ? "font-semibold text-[#0B1B3D]" : "text-[#5A6B7C] hover:text-[#0B1B3D] transition-colors"}
            >
              FR
            </button>
            <span className="text-[#E2E8F0]">|</span>
            <button
              data-testid="lang-en-button"
              onClick={() => setLang("en")}
              className={lang === "en" ? "font-semibold text-[#0B1B3D]" : "text-[#5A6B7C] hover:text-[#0B1B3D] transition-colors"}
            >
              EN
            </button>
          </div>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            className="md:hidden text-[#0B1B3D] p-1"
          >
            {open ? <X size={26} weight="bold" /> : <List size={26} weight="bold" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-b border-[#E2E8F0]">
          <nav className="px-6 py-4 flex flex-col">
            {links.map((l) => (
              <Link
                key={l.id}
                to={l.href}
                data-testid={`mobile-${l.id}`}
                onClick={() => setOpen(false)}
                className="py-3.5 text-base font-medium text-[#2A2D34] border-b border-[#F1F5F9] last:border-0 hover:text-[#0B1B3D] transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
